import { InputSelectOptionInterface } from 'common/module/input/select/option.interface';

/**
 * Check if option is selected
 *
 * @param selected - selected option or array of selected option ids
 * @param option - option
 */
export function inputSelectCheckIfSelected(selected: string | string[], option: InputSelectOptionInterface): boolean {
  if (Array.isArray(selected)) {
    return selected.indexOf(option.value) !== -1;
  }

  return selected === option.value;
}
